import { Modal, useMantineTheme } from "@mantine/core";
import React, { useState } from "react";
import { SqlModalProps } from "../../../../../../types/types";
import SqlEditor from "../editor/sqlEditor";
import QueryRunner from "../queryRunner/queryRunner";
import "./sqlModal.css";

export function SqlModal(props: SqlModalProps) {
  const theme = useMantineTheme();

  const [sqlQuery, setSqlQuery] = useState<string>("");
  const [sqlEditorOpened, setSqlEditorOpened] = useState<boolean>(true);
  const [sqlRunnerOpened, setSqlRunnerOpened] = useState<boolean>(false);

  const closeModal = () => {
    props && props.setOpenModal && props.setOpenModal(false)
    setSqlEditorOpened(true);
    setSqlRunnerOpened(false);
  }

  return (
    <div className="sqlModal-container">
      <Modal
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        opened={props.openModal as any}
        onClose={closeModal}
        radius="lg"
        size="1000px"
      >
        {sqlEditorOpened && <SqlEditor
          edit={props.edit as any}
          name={props.queryName as any}
          query={props.query ? props.query : (sqlQuery ? sqlQuery : "")}
          props={props.props as any}
          forceUpdate={props.forceUpdate}
          closeModal={closeModal}
          setSqlQuery={setSqlQuery}
          setSqlEditorOpened={setSqlEditorOpened}
          setSqlRunnerOpened={setSqlRunnerOpened}
        />}
        {sqlRunnerOpened && props.props && <QueryRunner
          executionMode={props.props?.kpiInfo.executionMode}
          name={props.queryName as string}
          query={sqlQuery}
          closeModal={closeModal}
          setSqlEditorOpened={setSqlEditorOpened}
          setSqlRunnerOpened={setSqlRunnerOpened}
        />}
      </Modal>
    </div>
  );
}
